import { gql } from '../__generated__';

gql(/* GraphQL */ `
  fragment BacklogItem on GuideModel {
    id
    docName
    docNumber
    docId
    docTitle
    hasChangesSinceLastPublish
    lastPublishedAt
    status
    isRevisionPlanned
    isRevisionAssesmentInProgress
    releases {
      id
      type
    }
    projectLeader
    authors {
      id
      name
    }
    planningScores {
      edition {
        value
        score
        boost
      }
      notices {
        value
        score
        boost
      }
      pageViews {
        value
        score
        boost
        placement {
          index
          total
        }
      }
    }
    owner {
      subjectId
      name
    }
    mainCategory {
      id
      title
    }
    notices {
      id
      title
      notice
      createdAt
      deletedAt
    }
    ongoingRevision {
      id
    }
  }
`);

export const GET_ALL = gql(/* GraphQL */ `
  query GetAllBacklogItems {
    guides(where: { status: { neq: EXPIRED } }) {
      ...BacklogItem
    }
  }
`);

